import axios from "axios"
import * as PermissionsTypes from "./PermissionTypes";

export function getUserLevel(userProfiles, profilesData) {
    const userProfilesData = profilesData.filter(profile => userProfiles.includes(profile.name));
    return Math.max(...userProfilesData.map(o => o.level), 0);
}

export default class Permissions {
    constructor() {
        this.permissions = [];
        this.profiles = [];
    }

    async init(uid, bid) {
        this.uid = uid;
        this.bid = bid;

        await Promise.all([
            this.setPermissionOfUser(this.uid, this.bid),
            this.setProfilesOfUser(this.uid, this.bid)
        ]);

        return this;
    }

    async setPermissionOfUser(uid, bid) {
        const {data: permissions} = await axios.get('/api/v2a/getUserPermissions', {params: {uid, bid}});
        this.permissions = permissions;
    }

    async setProfilesOfUser(uid, bid) {
        const {data: profiles} = await axios.get('/api/v2a/getUserProfiles', {params: {uid, bid}});
        this.profiles = profiles;
    }

    isPermitted(...permissions) {
        if (this.permissions.includes(PermissionsTypes.ALL))
            return true;

        for (let permissionsAndSequence of permissions) {
            permissionsAndSequence = Array.isArray(permissionsAndSequence) ? permissionsAndSequence : [permissionsAndSequence];
            let isSequencePermitted = true;

            for (let permission of permissionsAndSequence) {
                // If permission is missing, this AND sequence is false
                if (!this.permissions.includes(permission)) {
                    isSequencePermitted = false;

                    break;
                }
            }

            // Because the operator between each permissionsAndSequence is OR, if one of them is permitted, the
            // result is Permitted
            if (isSequencePermitted)
                return true;
        }

        return false
    }

    getProfiles() {
        return this.profiles;
    }

    getLevel(profilesData) {
        return getUserLevel(Object.keys(this.profiles), profilesData);
    }
}
